// extracted by mini-css-extract-plugin
export var cta = "CruiseSummary-module--cta--44bfd";
export var date = "CruiseSummary-module--date--71187";
export var name = "CruiseSummary-module--name--d13ef";
export var price = "CruiseSummary-module--price--05226";
export var priceColumn = "CruiseSummary-module--price-column--ec851";
export var promo = "CruiseSummary-module--promo--66be3";
export var summary = "CruiseSummary-module--summary--dd1c2";